<div class="flexCenter">
    <div class="loginTab boxShadow">
        <h1 style="text-align: center;">{{"activateaccount" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Title"}}</h1>
        <h4 style="text-align: center;">{{"AACC" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</h4>
        <app-formular [formBuilderInput]="modelInput" [formular]="formular" [passwordMinNonAlphanumericCharacters]="nonAlphaNumberic" [passwordMinUniqueChars]="uniqueChars" (action)="action($event)"></app-formular>
    </div>
</div>